export const SCHEDULE_STATUS = {
  success: 'success',
  error: 'error',
}

export const NOT_FOUND = 'notFound'
